<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<div class="w-100">
    <app-skelitions [hidden]="!isSkelition" [value]="2" class="mb-2"></app-skelitions>
</div>
<section *ngIf="!isSkelition" class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">
        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h"></h4>
            </div>
            <app-project-step [step]="'Weights'" [projectId]="projectId"></app-project-step>
        </div>
        <app-project-details-card *ngIf="basicChannels && project && !isSkelition" [project]="project"
            [channels]="basicChannels" [branches]="selectedBranches"></app-project-details-card>
        <div class="white-box">
            <p-messages [(value)]="messages" [enableService]="false"></p-messages>
            <div *ngIf="invalidWeight" class="alert alert-danger">
                <i class="pi pi-times-circle error-icon"></i>
                {{ 'The total weight should be 100' | translator }}
            </div>
            <div class="row px-4">
                <div class="col-md-6 col-12">
                    <div>
                        <h4 class="semi-h-pg-4"> {{'Channels Weight' | translator}} </h4>
                    </div>
                    <div class="grey-box">
                        <div class="d-flex">
                            <div class="width-100">
                                <h4 class="medium-h my-2">{{'Channels' | translator}}</h4>
                            </div>
                            <div>
                                <h4 class="medium-h mx-6 my-2"> {{'Visits' | translator}} </h4>
                            </div>
                            <div>
                                <h4 class="medium-h mx-2 my-2"> {{'Weights' | translator}} </h4>
                            </div>
                        </div>
                        <div class="d-flex" *ngFor="let channel of basicChannels">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">{{ channel.name | translator }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">
                                                <p-inputNumber [disabled]="true" inputId="integeronly" class="input-number-field" [styleClass]="'calender-hide'"
                                                    [min]="0" [max]="100" [inputStyle]="{ 'width': '100%', 'height': '100%', 'text-align': 'center' }"
                                                    [(ngModel)]="channel.visitCount"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">
                                                <p-inputNumber [disabled]="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) || statusType == 'Approved' || statusType == 'Pending' " inputId="integeronly" class="input-number-field" [styleClass]="'calender-hide'"
                                                    [min]="0" [max]="100" [inputStyle]="{ 'width': '100%', 'height': '100%', 'text-align': 'center' }"
                                                    [(ngModel)]="channel.weight" (ngModelChange)="isWeightValid()"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12" *ngIf="hasBranches">
                    <div>
                        <h4 class="semi-h-pg-4"> {{'Branches Weight' | translator}} </h4>
                    </div>
                    <div class="grey-box">
                        <div class="d-flex" *ngFor="let branch of branches; let i = index">
                            <div class="width-100">
                                <div *ngIf="i == 0" class="d-flex align-items-center">
                                    <div class="d-flex" [ngStyle]="{'margin-right.px': i === 0 ? 5 : 0}">
                                        <div class="ms-check-box" (click)=" (isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) ? null : checkAll(isCheckAll)">
                                            <i *ngIf="isCheckAll" class="pi pi-check"></i>
                                            <i *ngIf="!isCheckAll" class="pi pi-x"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-wrap">
                                        <h4 class="medium-h my-2">{{'Branches' | translator}}</h4>
                                    </div>
                                </div>
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box" (click)=" (isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) ? null : addRemoveBranch(branch)">
                                                <i *ngIf="branchSelected(branch)" class="pi pi-check"></i>
                                                <i *ngIf="!branchSelected(branch)" class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">{{ branch.name }} ({{ branch.location.name }})</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 *ngIf="i == 0" class="medium-h mx-2 my-2">{{'Weight' | translator}}</h4>
                                <div class="white-box-visits" [ngStyle]="{'margin-top.px': i === 0 ? 25 : 5}" >
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">
                                                <p-inputNumber *ngIf="branchSelected(branch)" inputId="integeronly" class="input-number-field"
                                                    [disabled]="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) || statusType == 'Approved' || statusType == 'Pending'" [min]="0" [max]="100"
                                                    [inputStyle]="{ 'width': '100%' }" [(ngModel)]="branch.weight" (ngModelChange)="isWeightValid()"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-1">
                    <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && (statusType == '' || statusType == 'Redo' || statusType == 'Change') " class="d-flex justify-content-end gap-1">
                        <button class="next-btn" (click)="submitForApproval()" >{{'SubmitMS' | translator}}</button>
                    </div>
                    <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) &&  !(statusType == 'Approved' || statusType == 'Pending') " class="d-flex justify-content-end gap-1">
                        <button class="next-btn" (click)="saveWeight()" >{{'Save' | translator}}</button>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Pending'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h p-3">{{'Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea" 
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="redoStatus()" class="re-do-btn mx-2">{{'Redo' | translator}} <i
                        class="fa-solid fa-arrows-rotate mx-2"></i></button>
                <button (click)="approveStatus()" class="next-btn">{{'Approve' | translator}} <i
                        class="pi pi-check-circle mx-2"></i></button>
            </div>
        </ng-container>
        <ng-container *ngIf="statusType != '' ">
            <div class="my-4 bg-comment-color mx-1" align="center">
                <h5 class="medium-h p-3" [ngClass]=" statusType == 'Approved' ? 'text-success' : (statusType == 'Change' ? '' : (statusType == 'Pending' ? '' : 'text-danger'))">
                    <ng-container *ngIf="statusType === 'Change' || statusType === 'Pending'; else defaultTemplate">
                        {{ 'Channels Weight' | translator }} {{ ('are in ' + statusType + ' State') | translator }}
                    </ng-container>
                    <ng-template #defaultTemplate>
                    {{ ('are in ' + statusType + ' State') | translator }} {{ (statusType == 'Approved') ?  ('Channels Weight' | translator) : '' }}
                    </ng-template>
                </h5>
                <h5 *ngIf="statusType == 'Redo' || statusType == 'Change'" class="medium-h p-3">{{ pmComment }}</h5>
            </div>
        </ng-container>
        <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Approved'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h p-3">{{'Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea" 
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="requestChange()" class="next-btn">{{'Request Change' | translator}}</button>
            </div>
        </ng-container>
        <div class="d-flex justify-content-end">
            <button [routerLink]="'/ms/criterias/'+projectId" class="next-btn">{{'Next' | translator}} <i
                    class="pi pi-arrow-left mx-2"></i></button>
        </div>

    </div>
</section>
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>